import CloseIcon from "@mui/icons-material/Close";
import { convertFontToSpan } from "../../../utils/services";
import CustomcoverPagePlaceholder from "../../../common/placeholder/CustomcoverPagePlaceholder";
import { Modal, Box, Typography, Grid, Button, IconButton } from "@mui/material";
import FroalaWithoutDropdown from "../../../common/froalaHtmlEditor/FroalaWithoutDropdown";

const EditCoverPage = ({ REPORT_SETTING_URL, editCoverModal, CloseCoverModal, editorContent, setEditorContent, sendSettings, editorRef }) => {
    const froalaConfig = {
        imagePaste: true,
        spellCheck: true,
        heightMin: 350,
        heightMax: 378,
        height: 378,
        autogrow: false,
        fontFamily: {
            'Arial': 'Arial',
            'Georgia': 'Georgia',
            'Impact': 'Impact',
            'Tahoma': 'Tahoma',
            'Times New Roman': 'Times New Roman',
            'Verdana': 'Verdana',
        },
        pluginsEnabled: ["wordPaste",
            "spellChecker",
            "codeBeautifier",
            "fontFamily",
            "fontSize",
            "colors",
            "align",
            "lists",
            "image",
            "lineHeight",
            "quote",
            "link",
            "table",
            "fullscreen",
            "print",
            "codeView",
        ],
        listAdvancedTypes: false,
        imageAllowedTypes: ['jpeg', 'jpg', 'png'],
        imageStyles: { 'fr-rounded': 'Rounded', 'fr-bordered': 'Bordered'},
        fontSize: ["8", "9", "10", "11", "12", "14", "16", "18", "20", "24", "28", "30", "32", "34", "36", "48", "60"],
        imageUploadURL: `${REPORT_SETTING_URL}/upload-media`,
        imageUploadMethod: 'POST',
        imageUploadParam: 'media_file',
        requestHeaders: { "company-key": sessionStorage.getItem("company_id") },
        events: {
            'image.uploaded': function (response) {
                console.log('Image uploaded', response);
            },
            'image.inserted': function ($img, response) {
                console.log('Image inserted', $img, response);
            },
            'image.error': function (error, response) {
                console.error('Image upload failed', error, response);
            },
        },
    }

    const toolbarButtonsConfig = {
        moreText: {
            // List of buttons used in the  group.
            buttons: ['bold', 'underline', 'italic', 'fontFamily', 'fontSize', 'textColor', 'clearFormatting'],
            // Alignment of the group in the toolbar.
            align: 'left',
            // By default, 3 buttons are shown in the main toolbar. The rest of them are available when using the more button.
            buttonsVisible: 5
        },
        moreParagraph: {
            buttons: ['formatOLSimple', 'formatUL', 'alignCenter', 'alignLeft', 'alignRight'],
            align: 'left',
            buttonsVisible: 3,
        },
        moreRich: {
            buttons: ['insertLink', 'insertImage', 'insertTable'],
            align: 'left',
            buttonsVisible: 3
        },
        moreMisc: {
            buttons: ['undo', 'redo', 'spellChecker', 'selectAll',],
            align: 'right',
            buttonsVisible: 0
        },
        // Change buttons for XS screen.
        toolbarButtonsXS: [['undo', 'redo'], ['bold', 'italic', 'underline']],
    };

    const handleChange = (name, content) => {
        setEditorContent((prevState) => ({ ...prevState, innerHTML: content }));
    };

    return <Modal open={editCoverModal} onClose={CloseCoverModal} className="edit-category-outer-modal" disableEnforceFocus
        disableAutoFocus>
        <Box sx={{ maxWidth: '1166px' }
        } className="edit-coverpage-modal" >
            {/* Header */}
            <Box display="flex" justifyContent="space-between" alignItems="center" >
                <Typography className='ci_title' >Cover Page</Typography>
                <IconButton onClick={CloseCoverModal} >
                    <CloseIcon />
                </IconButton>
            </Box>
            {/* Body */}
            <Box display="flex" gap={3} mt={2} >
                {/* Text Editor */}
                <Box flex={3} >
                    <Typography className="edit-title" sx={{ mb: "2px" }}>COVER PAGE</Typography>
                    {/* <HtmlCommentEditor editorContent={editorContent} froalaConfig={froalaConfig} /> */}
                    <FroalaWithoutDropdown showAI={false}
                        commentData={editorContent}
                        editorData={convertFontToSpan(editorContent)}
                        editor={editorRef}
                        id={"agreement-editor"}
                        onChange={handleChange}
                        froalaConfig={froalaConfig}
                        toolbarButtonsConfig={toolbarButtonsConfig} />
                </Box >
                {/* Placeholder List */}
                < Box flex={1} pl={2} >
                    <Typography className="edit-title">INSERT PLACEHOLDERS</Typography>
                    <CustomcoverPagePlaceholder editor={editorRef} setEditorContent={setEditorContent} />
                    <Box display="flex" justifyContent="flex-end" mt={1}>
                        <Grid container spacing={2} className="inspection-filter-modal-buttons">
                            <Button variant="outlined" onClick={CloseCoverModal} className="inspection-filter-modal-buttons-cancel">Cancel</Button>
                            <Button variant="contained" className="inspection-filter-modal-buttons-apply" onClick={sendSettings}>Apply</Button>
                        </Grid>
                    </Box>
                </Box >
            </Box >
            {/* Footer */}
        </Box >
    </Modal >
}

export default EditCoverPage;